/* Alpacas Foods — quantidade da PDP (stepper OU faixas por quantidade) + total.
   Porta a lógica de qty do PDP.tsx. Sem faixas, o comportamento é o de sempre. */
if (!customElements.get('product-buy')) {
  customElements.define('product-buy', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-qty-input]');
      this.dec = this.querySelector('[data-qty-dec]');
      this.inc = this.querySelector('[data-qty-inc]');
      this.tiers = Array.from(this.querySelectorAll('[data-tier]'));
      // [data-buy-*] ficam fora do elemento (CTA fixo mobile).
      this.totals = Array.from(this.querySelectorAll('[data-total]'))
        .concat(Array.from(document.querySelectorAll('[data-buy-total]')));
      this.qtyOut = Array.from(document.querySelectorAll('[data-buy-qty]'));
      this.unit = parseInt(this.dataset.unitPrice, 10) || 0; // em centavos
      this.max = parseInt(this.dataset.max, 10) || 20;

      if (this.dec) this.dec.addEventListener('click', function () { this.step(-1); }.bind(this));
      if (this.inc) this.inc.addEventListener('click', function () { this.step(1); }.bind(this));
      if (this.input) this.input.addEventListener('change', this.render.bind(this));
      if (this.tiers.length) {
        this.addEventListener('change', function (e) {
          if (!e.target.hasAttribute || !e.target.hasAttribute('data-tier')) return;
          this.tiers.forEach(function (t) {
            var card = t.closest('.alp-pack');
            if (card) card.classList.toggle('is-on', t.checked);
          });
          this.render();
        }.bind(this));
      }
      this.render();
    }
    checked() { return this.tiers.filter(function (t) { return t.checked; })[0] || null; }
    percent() { var t = this.checked(); return t ? (parseFloat(t.dataset.tierPct) || 0) : 0; }
    qty() {
      var t = this.checked();
      if (t) return parseInt(t.value, 10) || 1;
      if (!this.input) return 1;
      return Math.max(1, Math.min(this.max, parseInt(this.input.value, 10) || 1));
    }
    step(d) { if (!this.input) return; this.input.value = this.qty() + d; this.render(); }
    render() {
      var q = this.qty();
      if (this.input) this.input.value = q;
      if (this.dec) this.dec.disabled = q <= 1;
      var live = this.querySelector('[data-qty-live]');
      if (live) live.textContent = q;
      // Mesma conta do Liquid e da Shopify: percentual POR UNIDADE, centavos
      // truncados, e só então multiplica pela quantidade.
      var offUnit = Math.floor(this.unit * this.percent() / 100);
      var cents = (this.unit - offUnit) * q;
      var formatted = (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      this.totals.forEach(function (el) { el.textContent = formatted; });
      this.qtyOut.forEach(function (el) { el.textContent = q; });
    }
  });
}
